// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as HyperLogger$OrcaPaymentPage from "./hyper-log-catcher/HyperLogger.bs.js";
import * as LoggerUtils$OrcaPaymentPage from "./Utilities/LoggerUtils.bs.js";
import * as PaymentLoader$OrcaPaymentPage from "./Components/PaymentLoader.bs.js";

function ThreeDSMethod(props) {
  var logger = HyperLogger$OrcaPaymentPage.make(undefined, {
        TAG: "Elements",
        _0: "Payment"
      }, undefined, undefined, undefined, undefined);
  var stateMetadataRef = React.useRef({});
  var consumePostMessageForThreeDsMethodCompletionRef = React.useRef(false);
  var threeDsUrlRef = React.useRef("");
  var iframeRef = React.useRef(null);
  var initialLoadDoneRef = React.useRef(false);
  var isThreeDSMethodCompletionFired = React.useRef(false);
  var isThreeDSMethodFlowStarted = React.useRef(false);
  var match = React.useState(function () {
        return false;
      });
  var setIsClearInterval = match[1];
  var isClearInterval = match[0];
  var match$1 = React.useState(function () {
        return false;
      });
  var setIsStartTimeout = match$1[1];
  var isStartTimeout = match$1[0];
  var match$2 = React.useState(function () {
        return false;
      });
  var setIsStartPolling = match$2[1];
  var isStartPolling = match$2[0];
  var handleIframeContentLoaded = function () {
    Utils$OrcaPaymentPage.getDictFromJson(stateMetadataRef.current)["3dsMethodComp"] = "Y";
    var metadataDict = Core__Option.getOr(Core__JSON.Decode.object(stateMetadataRef.current), {});
    var iframeId = Utils$OrcaPaymentPage.getString(metadataDict, "iframeId", "");
    if (iframeId.length > 0 && !isThreeDSMethodCompletionFired.current) {
      LoggerUtils$OrcaPaymentPage.handleLogging(logger, "Y", "THREE_DS_METHOD_RESULT", "CARD", undefined);
      isThreeDSMethodCompletionFired.current = true;
      Utils$OrcaPaymentPage.messageParentWindow(undefined, [
            [
              "fullscreen",
              false
            ],
            [
              "param",
              "paymentloader"
            ],
            [
              "iframeId",
              iframeId
            ]
          ]);
      return Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                  [
                    "fullscreen",
                    true
                  ],
                  [
                    "param",
                    "3dsAuth"
                  ],
                  [
                    "iframeId",
                    iframeId
                  ],
                  [
                    "metadata",
                    stateMetadataRef.current
                  ]
                ]);
    }
    
  };
  var getIframeContentDocument = function () {
    var contentWindowDoc = Core__Option.flatMap(Core__Option.flatMap(Caml_option.nullable_to_opt(iframeRef.current), (function (ele) {
                return Caml_option.nullable_to_opt(ele.contentWindow);
              })), (function (ele) {
            return Caml_option.nullable_to_opt(ele.document);
          }));
    var contentDocument = Core__Option.flatMap(Caml_option.nullable_to_opt(iframeRef.current), (function (ele) {
            return Caml_option.nullable_to_opt(ele.contentDocument);
          }));
    if (contentDocument !== undefined) {
      return Caml_option.some(Caml_option.valFromOption(contentDocument));
    } else {
      return contentWindowDoc;
    }
  };
  var handleOnLoad = function (param) {
    if (consumePostMessageForThreeDsMethodCompletionRef.current) {
      return ;
    }
    try {
      var doc = getIframeContentDocument();
      if (doc === undefined) {
        return ;
      }
      var currentUrl = Caml_option.valFromOption(doc).location.href;
      if (!initialLoadDoneRef.current && (currentUrl === "about:blank" || currentUrl === "")) {
        initialLoadDoneRef.current = true;
        return ;
      } else {
        return handleIframeContentLoaded();
      }
    }
    catch (raw_err){
      var err = Caml_js_exceptions.internalToOCamlException(raw_err);
      var errorName = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.formatException(err)), "type", "");
      if (errorName === "SecurityError") {
        return handleIframeContentLoaded();
      } else {
        return ;
      }
    }
  };
  var handleOnError = function (value) {
    LoggerUtils$OrcaPaymentPage.handleLogging(logger, value, "THREE_DS_METHOD_RESULT", "CARD", "ERROR");
    Utils$OrcaPaymentPage.getDictFromJson(stateMetadataRef.current)["3dsMethodComp"] = "N";
    var metadataDict = Core__Option.getOr(Core__JSON.Decode.object(stateMetadataRef.current), {});
    var iframeId = Utils$OrcaPaymentPage.getString(metadataDict, "iframeId", "");
    if (iframeId.length > 0 && !isThreeDSMethodCompletionFired.current) {
      isThreeDSMethodCompletionFired.current = true;
      return Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                  [
                    "fullscreen",
                    true
                  ],
                  [
                    "param",
                    "3dsAuth"
                  ],
                  [
                    "iframeId",
                    iframeId
                  ],
                  [
                    "metadata",
                    stateMetadataRef.current
                  ]
                ]);
    }
    
  };
  var pollForCompletion = function () {
    if (isThreeDSMethodCompletionFired.current) {
      return setIsClearInterval(function (param) {
                  return true;
                });
    }
    try {
      var doc = getIframeContentDocument();
      if (doc === undefined) {
        return ;
      }
      var doc$1 = Caml_option.valFromOption(doc);
      var currentUrl = doc$1.location.href;
      if (doc$1.readyState === "complete" && initialLoadDoneRef.current && currentUrl !== "about:blank" && currentUrl !== "") {
        handleIframeContentLoaded();
        setIsClearInterval(function (param) {
              return true;
            });
      }
      if (!initialLoadDoneRef.current && currentUrl === "about:blank") {
        initialLoadDoneRef.current = true;
        return ;
      } else {
        return ;
      }
    }
    catch (raw_err){
      var err = Caml_js_exceptions.internalToOCamlException(raw_err);
      var errorName = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.formatException(err)), "type", "");
      if (errorName === "SecurityError") {
        setIsClearInterval(function (param) {
              return true;
            });
        return handleIframeContentLoaded();
      } else {
        return ;
      }
    }
  };
  React.useEffect((function () {
          if (!isStartPolling) {
            return ;
          }
          var intervalId = setInterval((function () {
                  pollForCompletion();
                }), 200);
          if (isClearInterval) {
            clearInterval(intervalId);
          }
          return (function () {
                    clearInterval(intervalId);
                  });
        }), [
        isClearInterval,
        isStartPolling
      ]);
  React.useEffect((function () {
          if (!isStartTimeout) {
            return ;
          }
          var timeoutId = setTimeout((function () {
                  handleOnError("Timeout while waiting for ThreeDS Method completion");
                }), 15000);
          return (function () {
                    clearTimeout(timeoutId);
                  });
        }), [isStartTimeout]);
  React.useEffect((function () {
          var handle = function (ev) {
            try {
              var json = Utils$OrcaPaymentPage.safeParse(ev.data);
              var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
              if (Core__Option.isSome(dict["fullScreenIframeMounted"]) && !isThreeDSMethodFlowStarted.current) {
                isThreeDSMethodFlowStarted.current = true;
                var metadata = Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "metadata");
                stateMetadataRef.current = metadata;
                var metaDataDict = Core__Option.getOr(Core__JSON.Decode.object(metadata), {});
                var threeDsDataDict = Core__Option.getOr(Core__Option.flatMap(metaDataDict["threeDSData"], Core__JSON.Decode.object), {});
                var threeDsMethodDetails = Utils$OrcaPaymentPage.getDictFromDict(threeDsDataDict, "three_ds_method_details");
                consumePostMessageForThreeDsMethodCompletionRef.current = Utils$OrcaPaymentPage.getBool(threeDsMethodDetails, "consume_post_message_for_three_ds_method_completion", false);
                var paymentIntentId = Utils$OrcaPaymentPage.getString(metaDataDict, "paymentIntentId", "");
                var publishableKey = Utils$OrcaPaymentPage.getString(metaDataDict, "publishableKey", "");
                logger.setClientSecret(paymentIntentId);
                logger.setMerchantId(publishableKey);
                var ele = document.querySelector("#threeDsInvisibleDiv");
                if (ele == null) {
                  handleOnError("Unable to Locate threeDsInvisibleDiv");
                } else {
                  threeDsUrlRef.current = Utils$OrcaPaymentPage.getString(threeDsMethodDetails, "three_ds_method_url", "");
                  var threeDsMethodData = Utils$OrcaPaymentPage.getString(threeDsMethodDetails, "three_ds_method_data", "");
                  var threeDsMethodKey = Utils$OrcaPaymentPage.getString(threeDsMethodDetails, "three_ds_method_key", "threeDSMethodData");
                  var form = Utils$OrcaPaymentPage.makeForm(ele, threeDsUrlRef.current, "threeDsHiddenPostMethod");
                  var input = document.createElement("input");
                  input.name = encodeURIComponent(threeDsMethodKey);
                  input.value = encodeURIComponent(threeDsMethodData);
                  form.target = "threeDsInvisibleIframe";
                  form.appendChild(input);
                  try {
                    if (!consumePostMessageForThreeDsMethodCompletionRef.current) {
                      setIsStartPolling(function (param) {
                            return true;
                          });
                    }
                    setIsStartTimeout(function (param) {
                          return true;
                        });
                    form.submit();
                  }
                  catch (raw_err){
                    var err = Caml_js_exceptions.internalToOCamlException(raw_err);
                    var exceptionMessage = JSON.stringify(Utils$OrcaPaymentPage.formatException(err));
                    handleOnError(exceptionMessage);
                  }
                }
              }
              
            }
            catch (_err){
              
            }
            if (!(consumePostMessageForThreeDsMethodCompletionRef.current && threeDsUrlRef.current !== "")) {
              return ;
            }
            var url = new URL(threeDsUrlRef.current);
            if (url.origin === ev.origin) {
              return handleIframeContentLoaded();
            }
            
          };
          window.addEventListener("message", handle);
          Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                  "iframeMountedCallback",
                  true
                ]]);
          return (function () {
                    window.removeEventListener("message", handle);
                  });
        }), []);
  return React.createElement(React.Fragment, {}, React.createElement(PaymentLoader$OrcaPaymentPage.make, {}), React.createElement("div", {
                  className: "hidden",
                  id: "threeDsInvisibleDiv"
                }), React.createElement("iframe", {
                  ref: Caml_option.some(iframeRef),
                  className: "h-96 invisible",
                  id: "threeDsInvisibleIframe",
                  style: {
                    outline: "none"
                  },
                  title: "3D Secure Invisible Frame",
                  name: "threeDsInvisibleIframe",
                  onError: (function (param) {
                      handleOnError("ThreeDS Method Iframe Load Error");
                    }),
                  onLoad: handleOnLoad
                }));
}

var make = ThreeDSMethod;

export {
  make ,
}
/* react Not a pure module */
